import * as React from 'react';

import './GridPlatformNameCell.css';

interface GridPlatformNameCellProps {
    name: string;
}

export function MarkedText({ name }: GridPlatformNameCellProps): JSX.Element {
    return <div className="grid-platform-name-cell">{name}</div>;
}
